import axios from "axios";

const envBaseUrl = process.env.REACT_APP_API_BASE_URL;
const hostname = typeof window !== "undefined" ? window.location?.hostname : "";
const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
const isEnvLocal =
  typeof envBaseUrl === "string" &&
  (envBaseUrl.includes("localhost") || envBaseUrl.includes("127.0.0.1"));

const FALLBACK_API_BASE_URL = isLocalHost
  ? "http://127.0.0.1:8000/api"
  : "https://api.krayneagency.fr/api";

const API_BASE_URL =
  envBaseUrl && (isLocalHost || !isEnvLocal) ? envBaseUrl : FALLBACK_API_BASE_URL;

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const login = async (email, password) => {
  try {
    const response = await api.post("/login", {
      email,
      password,
    });
    console.log("Connexion réussie:", response.data);
    // Traitement du token: le backend renvoie data.access_token.token
    const token = response?.data?.data?.access_token?.token;
    if (token) {
      localStorage.setItem("access_token", token);
    } else {
      console.warn("Token non trouvé dans la réponse de /login", response.data);
    }
  } catch (error) {
    console.error("Erreur lors de la connexion:", error);
    // Gérer l'erreur ici (afficher un message à l'utilisateur, etc.)
  }
};

// Récupérer l'utilisateur courant (nécessite le header Authorization)
export const getCurrentUser = async () => {
  try {
    const { data } = await api.get("/currentuser");
    return data?.data?.user;
  } catch (error) {
    console.error("Erreur lors de la récupération du current user:", error);
    return null;
  }
};
